/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import reportService from '../../services/ReportService';
import ReportTypes from '../types/ReportTypes';

//* get all department list items
function getSummaryReport(postData, setErrors, setSubmitting) {
  return async (dispatch) => {
    dispatch({ type: ReportTypes.GET_SUMMARY_REPORT_REQUEST });
    try {
      const res = await reportService.getSummaryReport(postData, setErrors, setSubmitting);
      dispatch({
        type: ReportTypes.GET_SUMMARY_REPORT_SUCCESS,
        payload: res.data
      });
      if (setSubmitting) {
        setSubmitting(false);
      }
    } catch (error) {
      if (error && error.response) {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch({
          type: ReportTypes.GET_SUMMARY_REPORT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            if (setErrors) {
              setErrors(error.response.data.errors);
            }
          }
        }
      }
      //
    }
  };
}

function getAgeingReport(postData, setErrors, setSubmitting) {
  return async (dispatch) => {
    dispatch({ type: ReportTypes.GET_AGEING_REPORT_REQUEST });
    try {
      const res = await reportService.getAgeingReport(postData, setErrors, setSubmitting);
      dispatch({
        type: ReportTypes.GET_AGEING_REPORT_SUCCESS,
        payload: res.data
      });
      if (setSubmitting) {
        setSubmitting(false);
      }
    } catch (error) {
      if (error && error.response) {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch({
          type: ReportTypes.GET_AGEING_REPORT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            if (setErrors) {
              setErrors(error.response.data.errors);
            }
          }
        }
      }
      //
    }
  };
}

function getFilters() {
  return async (dispatch) => {
    dispatch({ type: ReportTypes.GET_REPORT_FILTER_REQUEST });
    try {
      const res = await reportService.getFilters();
      dispatch({
        type: ReportTypes.GET_REPORT_FILTER_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: ReportTypes.GET_REPORT_FILTER_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getSummaryFilters() {
  return async (dispatch) => {
    dispatch({ type: ReportTypes.GET_SUMMARY_REPORT_FILTER_REQUEST });
    try {
      const res = await reportService.getSummaryFilters();
      dispatch({
        type: ReportTypes.GET_SUMMARY_REPORT_FILTER_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: ReportTypes.GET_SUMMARY_REPORT_FILTER_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getAgeingFilters() {
  return async (dispatch) => {
    dispatch({ type: ReportTypes.GET_AGEING_REPORT_FILTER_REQUEST });
    try {
      const res = await reportService.getAgeingFilters();
      dispatch({
        type: ReportTypes.GET_AGEING_REPORT_FILTER_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: ReportTypes.GET_AGEING_REPORT_FILTER_ERROR,
          error: error.response
        });
      }
    }
  };
}

function clientBasedReport(postData, setErrors, setSubmitting) {
  return async (dispatch) => {
    dispatch({ type: ReportTypes.CLIENT_BASED_REPORT_REQUEST });
    try {
      const res = await reportService.clientBasedReport(postData);
      dispatch({
        type: ReportTypes.CLIENT_BASED_REPORT_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      if (setSubmitting) {
        setSubmitting(false);
      }
    } catch (error) {
      if (error && error.response) {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch({
          type: ReportTypes.CLIENT_BASED_REPORT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            if (setErrors) {
              setErrors(error.response.data.errors);
            }
          }
        }
      }
    }
  };
}

function deptBasedReport(postData, setErrors, setSubmitting) {
  return async (dispatch) => {
    dispatch({ type: ReportTypes.DEPARTMENT_BASED_REPORT_REQUEST });
    try {
      const res = await reportService.deptBasedReport(postData);
      dispatch({
        type: ReportTypes.DEPARTMENT_BASED_REPORT_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      if (setSubmitting) {
        setSubmitting(false);
      }
    } catch (error) {
      if (error && error.response) {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch({
          type: ReportTypes.DEPARTMENT_BASED_REPORT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            if (setErrors) {
              setErrors(error.response.data.errors);
            }
          }
        }
      }
    }
  };
}

const ReportAction = {
  getSummaryReport,
  clientBasedReport,
  getFilters,
  getSummaryFilters,
  deptBasedReport,
  getAgeingFilters,
  getAgeingReport
};

export default ReportAction;
